import { isNumber, isPlainObject, isString, kebabCase } from "lodash-es";

const prefix = "--y-";

const formatName = name => {
  return prefix + kebabCase(name);
};

const setCssVariables = (key, value) => {
  let result = "";
  if (isPlainObject(value)) {
    Object.keys(value).forEach(k => {
      result += setCssVariables(`${key}-${k}`, value[k]);
    });
  } else if (isString(value) || isNumber(value)) {
    const name = formatName(key);
    result += `${name}:${value};\n`;
  }
  return result;
};
const STYLE_ID = "channel-css-variable";
export const initTheme = configs => {
  const cssVariables = setCssVariables("", configs);
  const styleText = `
  @charset "UTF-8";
  :root{
    ${cssVariables}
  }
  `;

  if (document.querySelector(`#${STYLE_ID}`)) {
    document.querySelector(`#${STYLE_ID}`).innerHTML = styleText;
  } else {
    const style = document.createElement("style");
    style.type = "text/css";
    style.id = STYLE_ID;
    style.innerHTML = styleText;
    document.head.appendChild(style);
  }
};
